/*
 * Application State should be all within this file.
 */

const app = {
  state: {
    savedLocation: 0
  },
  mutations: {
    SET_SAVED_LOCATION(state, value) {
      state.savedLocation = value;
    }
  },
  actions: {
    setSavedLocation({ commit }, value) {
      commit("SET_SAVED_LOCATION", value);
    },
    mapFromDatastore({ commit, state }, payload) {
      /*
       * This is called whenever the Datastore/entry changes.
       * This is an opportunity for you to map stored values
       * back into your state.
       */
      let _payload = state;
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      /*
       * Call a mutation to put your datastore payload into your app state
       */
      commit(
        "SET_SAVED_LOCATION",
        _payload?.savedLocation ?? state.savedLocation
      );
    }
  },
  getters: {
    getSavedLocation(state) {
      return state.savedLocation;
    },
    getExample(state) {
      /*
       * Demo only, remove during development
       */
      return state.example;
    },
    getExampleFormFields(state) {
      /*
       * Demo only, remove during development
       */
      return state.exampleFormFields;
    },
    mapToDatastore(state) {
      /*
       * Datastore Payload is only used whenever you're using the
       * Datastore (or Datasheets). This is an object
       */

      let payload = {
        savedLocation: state.savedLocation
      };

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
